/*
 * Custom dual-handle price range slider for the collection filters.
 * Replaces Dawn's From/To number inputs with a slider; applies the
 * filter.v.price.gte / .lte params on release. Works desktop + mobile.
 */
(function () {
  'use strict';

  function num(v) { return parseInt(String(v == null ? '' : v).replace(/[^0-9]/g, ''), 10) || 0; }
  function money(n) { return '$' + Number(n).toLocaleString('en-AU'); }

  function enhance(priceEl) {
    if (priceEl.getAttribute('data-pb-slider')) return;
    var minInput = priceEl.querySelector('input[name$=".price.gte"], input[name*="price.gte"]');
    var maxInput = priceEl.querySelector('input[name$=".price.lte"], input[name*="price.lte"]');
    if (!minInput || !maxInput) return;

    var absMax = num(maxInput.getAttribute('data-max')) || num(maxInput.getAttribute('placeholder'));
    if (absMax <= 0) return;
    var curMin = num(minInput.value);
    var curMax = num(maxInput.value) || absMax;

    priceEl.setAttribute('data-pb-slider', '1');

    // Open the price group by default on the desktop vertical panel.
    var det = priceEl.closest('details.facets__disclosure-vertical');
    if (det && !det.open) det.open = true;

    var wrap = document.createElement('div');
    wrap.className = 'pb-price-slider';
    wrap.innerHTML =
      '<div class="pb-price-slider__values">' +
        '<span class="pb-price-slider__val pb-price-slider__val--min"></span>' +
        '<span class="pb-price-slider__val pb-price-slider__val--max"></span>' +
      '</div>' +
      '<div class="pb-price-slider__rail"><div class="pb-price-slider__fill"></div></div>' +
      '<input type="range" class="pb-price-slider__range pb-price-slider__range--min" min="0" max="' + absMax + '" value="' + curMin + '" step="1" aria-label="Minimum price">' +
      '<input type="range" class="pb-price-slider__range pb-price-slider__range--max" min="0" max="' + absMax + '" value="' + curMax + '" step="1" aria-label="Maximum price">';
    priceEl.appendChild(wrap);

    var rMin = wrap.querySelector('.pb-price-slider__range--min');
    var rMax = wrap.querySelector('.pb-price-slider__range--max');
    var fill = wrap.querySelector('.pb-price-slider__fill');
    var vMin = wrap.querySelector('.pb-price-slider__val--min');
    var vMax = wrap.querySelector('.pb-price-slider__val--max');

    function bounds() {
      var a = parseInt(rMin.value, 10);
      var b = parseInt(rMax.value, 10);
      if (a > b) { var t = a; a = b; b = t; }
      return [a, b];
    }
    function paint() {
      var pair = bounds(), a = pair[0], b = pair[1];
      fill.style.left = (a / absMax * 100) + '%';
      fill.style.right = (100 - b / absMax * 100) + '%';
      vMin.textContent = money(a);
      vMax.textContent = money(b);
      rMin.style.zIndex = (a >= absMax * 0.98) ? 5 : 3;
    }
    function commit() {
      var pair = bounds(), a = pair[0], b = pair[1];
      var url = new URL(window.location.href);
      if (a > 0) url.searchParams.set(minInput.name, a); else url.searchParams.delete(minInput.name);
      if (b < absMax) url.searchParams.set(maxInput.name, b); else url.searchParams.delete(maxInput.name);
      window.location.href = url.toString();
    }

    rMin.addEventListener('input', paint);
    rMax.addEventListener('input', paint);
    rMin.addEventListener('change', commit);
    rMax.addEventListener('change', commit);
    paint();
  }

  function run() {
    var list = document.querySelectorAll('.facets__price');
    for (var i = 0; i < list.length; i++) enhance(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
